import React from 'react';

const Actions = () => {
  return (
    <svg width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d)">
        <rect x="32" y="45.5718" width="79" height="76" rx="6" transform="rotate(-5.5 32 45.5718)" fill="white" />
        <rect
          x="31.7272"
          y="45.3469"
          width="79.5"
          height="76.5"
          rx="6.25"
          transform="rotate(-5.5 31.7272 45.3469)"
          stroke="#E6E9EC"
          strokeWidth="0.5"
        />
      </g>
      <rect x="46.8418" y="95.3784" width="48" height="4" transform="rotate(-5.5 46.8418 95.3784)" fill="#E6E9EC" />
      <rect x="47.7051" y="104.337" width="16" height="4" transform="rotate(-5.5 47.7051 104.337)" fill="#E6E9EC" />
      <rect
        x="42.7207"
        y="52.5764"
        width="20"
        height="20"
        rx="10"
        transform="rotate(-5.5 42.7207 52.5764)"
        fill="#C1C3C6"
      />
      <path
        d="M50.6148 61.5276L53.4929 63.5946L56.7593 59.2616"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g filter="url(#filter1_d)">
        <rect x="50" y="42" width="79" height="76" rx="6" fill="white" />
        <rect x="49.75" y="41.75" width="79.5" height="76.5" rx="6.25" stroke="#E6E9EC" strokeWidth="0.5" />
      </g>
      <rect x="60" y="93" width="48" height="4" fill="#787F88" />
      <rect x="60" y="102" width="16" height="4" fill="#E6E9EC" />
      <rect x="60" y="50" width="20" height="20" rx="10" fill="#6D61FF" />
      <path
        d="M67 59.6667L69.6667 62L73.3333 58"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_d"
          x="28.0469"
          y="36.0469"
          width="93.8266"
          height="91.1279"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="filter1_d"
          x="45.5"
          y="39.5"
          width="88"
          height="85"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default Actions;
